export default "__VITE_ASSET__2f1643a7__"